import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { VesselType } from 'src/app/front-user/shared/models/vesselType.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { FloatingCranesRequestDTO } from '../../models/FloatingCranesRequestDTO.model';
import { FloatingCranesRequestService } from '../../services/floating-cranes-request.service';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Attachment } from 'src/app/front-user/shared/models/attachment.model';
import { NearestLocation, AttachmentType, Languages, MesurementUnit, Service } from 'src/app/shared/models/enums.model';
import { ActivatedRoute } from '@angular/router';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { CustomValidators } from '../../models/custom-validator';
import { FileValidator } from 'src/app/front-user/shared/validator/file-input.validator';
import { config } from 'rxjs';
import { AppConfig } from 'src/app/shared/services/app.config';
import { BaseUserDto } from 'src/app/shared/models/base-user.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { BaseRequestService } from '../../services/base-request.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';

@Component({
  selector: 'app-create-floating-cranes-request',
  templateUrl: './create-floating-cranes-request.component.html',
  styleUrls: ['./create-floating-cranes-request.component.css']
})

export class CreateFloatingCranesRequestComponent implements OnInit {
  addFloatingCarnesRequestForm: FormGroup;
  model: FloatingCranesRequestDTO;
  vesselType: VesselType[];
  responseObj: ResponseObject;
  nearestLocation = NearestLocation;
  requestId: any;
  nearestLocationKeys = Object.keys(this.nearestLocation);
  isReadOnly: boolean
  shipPhotoAttachmentUrl;
  ObjectToLiftPhotoAttachmentUrl;
  AttachmentType: typeof AttachmentType;
  submitted = false;
  showSuccessMessage: boolean;
  showUnsuccessMessage: boolean;
  responseObject: ResponseObject;
  ShipPhotoProgress: number;
  objectToLiftPhotoProgress: number;
  displayedLang: string;
  mesurementUnit = MesurementUnit;
  mesurementUnitKeys = Object.keys(this.mesurementUnit);
  uploadResponse = { status: '', message: '', filePath: '' };
  numberRegex: string = '^[0-9]*$';
  charRegex: string = '^[a-zA-Z\\s]*$';
  dateToSelectRequestExecutingDate: Date;
  dateToSelectRequestExecutingDateForValidation: string;
  showRequest = true;
  dateOfNextTwoDays = new Date();
  progress: number;
  isErrorMessage:boolean=false;
  userInfo: any;
  baseRequestDTO: BaseRequest;


  constructor(private lookupService: LookupService,
    private floatingCranesRequestService: FloatingCranesRequestService,
    private fileService: fileService,
    private formBuilder: FormBuilder,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private globalSrv: GlobalServices,
    private baseRequestService: BaseRequestService,
    private alertService: AlertService,
    private authSrevice: AuthenticationService) {
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    this.nearestLocationKeys = this.nearestLocationKeys.slice(this.nearestLocationKeys.length / 2);
    this.model = new FloatingCranesRequestDTO();
    this.mesurementUnitKeys = this.mesurementUnitKeys.slice(this.mesurementUnitKeys.length / 2);
    this.GetDateToSelectRequestExecutingDate();
  }

  ngOnInit() {
    if (history.state.data && history.state.data.requestId)
      this.requestId = history.state.data.requestId;
      if(this.requestId){
      this.getBaseRequest();
      }
    this.isReadOnly = this.requestId != null ? true : false;
    if (history.state.data && history.state.data.isCompleted){
      this.isReadOnly = true;
     }else if((!history.state.data )&&this.authSrevice.currentUserValue.IsAdmin){
      window.history.back();
    }
    this.buildForm();
    if (this.isReadOnly) {
      this.getFloatingCarnesRequest();
    }
    this.lookupService.getVesselTypes().subscribe(
      d => {
        this.vesselType = d.Data;
      });
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.addFloatingCarnesRequestForm.controls;
  }

  get Attachment() {
    return AttachmentType;
  }

  GetDateToSelectRequestExecutingDate() {
    this.floatingCranesRequestService.GetNumberOfDaysToSelectRequestExecutingDate().subscribe(
      r => {
        let days = r.Data;
        var date = new Date();
        date.setDate(date.getDate() + Number(days) + 1);
        this.dateToSelectRequestExecutingDate = new Date(date.toLocaleString().split(',')[0]);
      }
    );
  }

  getFloatingCarnesRequest() {
    this.floatingCranesRequestService.GetFloatingCranesRequest(this.requestId).subscribe(
      d => {
        this.model = d.Data;
        this.addFloatingCarnesRequestForm.patchValue({
          Description: this.model.Description,
          ExpectedRequestExecutingDate: this.model.ExpectedRequestExecutingDate,
          MaxOutreach: this.model.MaxOutreach,
          MaxOutreachUnit: this.model.MaxOutreachUnit,
          NearestLocation: this.model.NearestLocation,
          SupportsFromCustomer: this.model.SupportsFromCustomer,
          TotalWeight: this.model.TotalWeight,
          VesselType: this.model.VesselType,
          VesselTypeId: this.model.VesselTypeId,
          EstimatedHoursToDoneRequest: this.model.EstimatedHoursToDoneRequest,
          MobileNumber: this.model.MobileNumber,
          Fax: this.model.Fax,
          TermsAndConditions: true
        });
        this.userInfo={
          MobileNumber: this.model.MobileNumber,
          Fax: this.model.Fax
        }
        var baseUrl=AppConfig.settings.apiServer.UploadsUrl;
        var shipyardUploadsFolder=AppConfig.settings.apiServer.ShipyardUploadsFolder;

         this.shipPhotoAttachmentUrl  = this.model.Attachments.find(x => x.AttachmentType == AttachmentType.ShipPhoto) != undefined ?

         this.model.Attachments.find(x => x.AttachmentType == AttachmentType.ShipPhoto).URL : '';
         this.ObjectToLiftPhotoAttachmentUrl = this.model.Attachments.find(x => x.AttachmentType == AttachmentType.ObjectToLiftPhoto) != undefined ?
         this.model.Attachments.find(x => x.AttachmentType == AttachmentType.ObjectToLiftPhoto).URL : '';

         this.shipPhotoAttachmentUrl=    baseUrl+ shipyardUploadsFolder+"/"+ this.shipPhotoAttachmentUrl;
         this.ObjectToLiftPhotoAttachmentUrl=    baseUrl+ shipyardUploadsFolder+"/"+ this.ObjectToLiftPhotoAttachmentUrl;

      });
  }


  getBaseRequest() {

    this.baseRequestService.getBaseRequest(this.requestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;

      }
    )
  }

  async onFileSelected(event, currFormControl, docName, attachmentType: AttachmentType, progressVariableName,key) {
    this[progressVariableName] = 0;
    this.alertService.clear();
    let localizationKeyValue = await this.translate.get(key).toPromise();
    if (!this.fileService.IsFileExtentionValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElements = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      return false;
      // this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
      //   alert(res);
      //   return false;
      // });
    }

    if (!this.fileService.IsFileSizeValid(event)) {
      currFormControl.setValue('');
      var errorMessage = await this.translate.get('FRONT_USER.NotAllowedFileSize').toPromise();
      this.alertService.error(localizationKeyValue + ' ' + errorMessage);
      let invalidElement = document.getElementsByClassName('alert-danger');
      event.target.value = "";
      window.scrollTo(0, 0);
      return false;

    }

    const file = event.target.files[0];
    const formData = new FormData();
    formData.append('File', file);
    formData.append('DocumentName', docName);
    formData.append('FolderName', AppConfig.settings.apiServer.ShipyardUploadsFolder);
    this.fileService.fileUploader(formData).subscribe(
      event => {
        if (event.type === HttpEventType.UploadProgress) {
          // This is an upload progress event. Compute and show the % done:
          const percentDone = Math.round(100 * event.loaded / event.total);
          this[progressVariableName] = percentDone;
          currFormControl.setErrors({'invalid': true});

        } else if (event instanceof HttpResponse) {
          const jsonResponse = event.body.Data;
          const Url = jsonResponse.Url;
          const attachment = new Attachment();
          attachment.URL = Url;
          attachment.DocumentName = docName;
          attachment.AttachmentTypeId = attachmentType;
          this.model.Attachments = this.model.Attachments.filter(h => h.AttachmentType !== attachmentType);
          this.model.Attachments.push(attachment);
          currFormControl.setErrors(null);
        }
      }
    );




  }

  onSubmit() {
    this.submitted = true;
    const invalid = [];
    const controls = this.addFloatingCarnesRequestForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }

    // stop here if form is invalid
    if (this.addFloatingCarnesRequestForm.invalid||this.addFloatingCarnesRequestForm.controls['VesselTypeId'].value=='null'||this.addFloatingCarnesRequestForm.controls['MaxOutreachUnit'].value=='null') {
      return;
    }

    //this.addFloatingCarnesRequestForm.controls['MobileNumber'].setValue(this.addFloatingCarnesRequestForm.controls.MobileNumber.value.internationalNumber);
    //Enable Loader
    this.globalSrv.isLoaderEnabled = true;
    this.model.Description = this.addFloatingCarnesRequestForm.get("Description").value;
    this.model.SupportsFromCustomer = this.addFloatingCarnesRequestForm.get("SupportsFromCustomer").value;
    this.model.ExpectedRequestExecutingDate = this.addFloatingCarnesRequestForm.get("ExpectedRequestExecutingDate").value;
    this.model.MaxOutreach = this.addFloatingCarnesRequestForm.get("MaxOutreach").value;
    this.model.MaxOutreachUnit = this.addFloatingCarnesRequestForm.get("MaxOutreachUnit").value;
    this.model.NearestLocation = this.addFloatingCarnesRequestForm.get("NearestLocation").value;
    this.model.TotalWeight = this.addFloatingCarnesRequestForm.get("TotalWeight").value;
    this.model.VesselTypeId = this.addFloatingCarnesRequestForm.get("VesselTypeId").value;
    this.model.EstimatedHoursToDoneRequest = this.addFloatingCarnesRequestForm.get("EstimatedHoursToDoneRequest").value;
    this.model.Fax = this.addFloatingCarnesRequestForm.get("Fax").value;
    this.model.MobileNumber = this.addFloatingCarnesRequestForm.controls.MobileNumber.value;
    this.model.RequestorId = this.authSrevice.currentUserValue.UserId;
    this.model.ServiceId = Service.FloatingCranes;
    this.floatingCranesRequestService.CreateFloatingCranesRequest(this.model).subscribe(
      (data: ResponseObject) => {
        this.responseObj = data;
        if (this.responseObj.Success) {
          let message: string;
          this.addFloatingCarnesRequestForm.reset();
          this.showRequest = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;
          // console.log("Success");
        }
        else {
          this.isErrorMessage = true;
          this.showRequest = false;
          //Disable Loader
          this.globalSrv.isLoaderEnabled = false;


        }
      });
  }

  buildForm() {
    this.addFloatingCarnesRequestForm = this.formBuilder.group({
      Description: ['', [Validators.required, Validators.maxLength(500), CustomValidators.textSpaceValidator()]],
      VesselTypeId: [null, [Validators.required]],
      MaxOutreach: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      MaxOutreachUnit: [null, [Validators.required]],
      TotalWeight: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      NearestLocation: ['', [Validators.required]],
      ShipPhotoInput: ['', [FileValidator.validate]],
      ObjectToLiftPhotoInput: ['', [FileValidator.validate]],
      ExpectedRequestExecutingDate: ['', [Validators.required, CustomValidators.dateValidator(), CustomValidators.NextTwoDaysDateValidator(this.dateToSelectRequestExecutingDate)]],
      SupportsFromCustomer: ['', [Validators.required, CustomValidators.textSpaceValidator(), Validators.maxLength(500)]],
      EstimatedHoursToDoneRequest: ['', [Validators.required, Validators.pattern(this.numberRegex)]],
      TermsAndConditions: [false, [Validators.requiredTrue]]
    });
  }

  goToTermsAndConditions(): void {
    if (this.globalSrv.getLanguage() == Languages.Arabic)
        window.open(AppConfig.settings.apiServer.ShipyardTermsAR, '_blank');
    else
        window.open(AppConfig.settings.apiServer.ShipyardTermsEN, '_blank');
  }
}
